import { render } from "./Restore.vue?vue&type=template&id=0a4c25b0&scoped=true"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"

import "./Restore.vue?vue&type=style&index=0&id=0a4c25b0&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4c25b0"]])

export default __exports__